import { createAction } from 'redux-actions';
export const LOCK_FORM = 'LOCK_FORM';
export const UNLOCK_FORM = 'UNLOCK_FORM';
// #todo: add tests
export const unlockForm = createAction(UNLOCK_FORM);
export const lockForm = createAction(LOCK_FORM);
